import React, { useEffect, useState } from "react";
import ProzoDataGrid, { lastPageRowCount, useFirstPageOnChange } from "../../../common/ProzoDataGrid";
import { orderStatusClause } from './OrderStatusFilter';
import { Chip, Grid, Button, Typography, Box, Stack, Tooltip, Switch, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Divider, Link as MuiLink } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLazyGetShipmentDetailQuery } from '../../../redux/commonRTK';
import useCourierServiceType from '../../../hooks/useCourierServiceType';
import {
  getOrderLists,
  syncOrder,
} from "../../../redux/actions/orderList/orderListAction";
import { apiConstants, get, getGeneric, postGeneric } from "../../../common/constants";
import { resetOrderList } from "../../../redux/reducers/orderList/orderListSlice";
import Loader from "../../../common/Loader";
import {
  parseDateAndTime,
  getTotalUnitsOfOrder,
  shouldMaskData,
  maskAddress,
  formatCurrency,
  TicketSuccessModal,
  formatDate,
} from "../../../helpers/UtilityHelper";
import { exclude, ItemListModal } from "./index";
import NetraScoreBadge from "../NetraScoreBadge";
import RtoRiskBadge from "../RtoRiskBadge";
import { RTO_BAND3_TO_NETRA } from "../rtoBand";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MUIModal from "../../../common/MUIModal";
/* import CreateIcon from "@mui/icons-material/Create"; */
import Remarks from "../../Remarks/Remarks";
// import ConfirmDialog from "../../../common/ConfirmDialog";
import { useSnackbar } from "notistack";
import { FormProvider, RHFRadioGroup, RHFSelectField } from "../../../common/hook-form";
import { useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import PageTitle from "../../../common/PageTitle";
import { useGetCouriersQuery } from "../../../redux/commonRTKPersist";
import _ from 'lodash'
import { addDays, format } from "date-fns";
import ConfirmDialog from '../../../common/ConfirmDialog';
import AppointmentDelivery from "./AddAppDelivery";
import CloneWithEditModal from "./CloneWithEditModal";
import MarkRtoRequestedModal, { isRtoBlocked } from "../MarkRtoRequestedModal";
import jwt_decode from "jwt-decode"
import { getMerchant, getToken, getRole } from "../../../helpers/ReduxHelpers";
import SideDrawer from "../../weight/list/SideDrawer";
import CreateTicket from "../../EscalationManagement/CreateTicket";
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DescriptionIcon from '@mui/icons-material/Description';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SyncIcon from '@mui/icons-material/Sync';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ReplayIcon from '@mui/icons-material/Replay';
import DownloadIcon from '@mui/icons-material/Download';
import RaiseClaimModal from "../../claims/RaiseClaimModal";
import AddAdditionalDocuments from "./AddAdditionalDocuments";
import DocumentsModal from "../DocumentsModal";
import ViewDocumentsDialog, { VIEW_DOCS_TITLES } from "../ViewDocumentsDialog";
import AssignmentIcon from '@mui/icons-material/Assignment';
import { primaryTextSx, secondaryTextSx, tertiaryTextSx, awbTextSx, cellStackSx, getStatusChipSx, getPaymentChipSx } from './cellStyles';
import ClientOrderIdText, { clientOrderIdClause } from './ClientOrderIdText';
import AwbLinkCell from '../../../common/AwbLinkCell';
import PodViewCell from './PodViewCell';
import { abdFlagFilter } from '../../appointments/shared/constants';

// Statuses that end a shipment without a delivery, plus delivered: never an open EDD breach.
const EDD_BREACH_CLOSED_STATUSES = ['DELIVERED', 'CANCELLED_ORDER', 'RTO_REQUESTED', 'RTO', 'RTO_INTRANSIT', 'RTO_CONTACT_CUSTOMER_CARE',
  'RTO_SHIPMENT_DELAY', 'RTO_OUT_FOR_DELIVERY', 'RTO_FAILED', 'RTO_DELIVERED', 'LOST', 'DAMAGED'];

const AllOrders = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { orderListInfo, loading } = useSelector(
    (state) => state.orderListSlice
  );
  const { loading: orderSummaryLoading } = useSelector(
    (state) => state.orderSummarySlice
  );
  const [page, setPage] = useState(0);
  const [sizePerPage, setSizePerPage] = useState(10);
  // New filters applied: start again from the first page.
  useFirstPageOnChange(props.filterChange, setPage);
  const [getShipmentDetail] = useLazyGetShipmentDetailQuery();
  // const { fromDate: from_date, toDate: to_date } = getDashboardDateFilter('last_30_days')
  const [itemModal, setItemModal] = useState(false);
  const [itemModalData, setItemModalData] = useState();
  const [open, setOpen] = useState(false);
  const [clone, setClone] = useState(false);
  const [cloneWithEdit, setCloneWithEdit] = useState(false);
  const [cloneWithEditRow, setCloneWithEditRow] = useState(null);
  const [id, setId] = useState();
  const [reload, setReload] = useState(0);
  const { piiAccessAllow } = jwt_decode(getToken());
  const paymentMode = [{ label: "PREPAID", value: "PREPAID" }, { label: "COD", value: "COD" }]
  const methods = useForm({
    defaultValues: {
      payment_mode: '',
      courier_type: ''
    }
  });
  const { handleSubmit, setValue, watch, reset: resetClone } = methods;
  const [data, setData] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { report } = useSelector(state => state);
  const courierSelection = watch('courier_type')
  const [courierData, setCourierData] = useState()
  const [newCourier, setNewCourier] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [cancelConfirm, setCancelConfirm] = useState(false);
  const [delConfirm, setDelConfirm] = useState(false);
  const [rtoModalOpen, setRtoModalOpen] = useState(false);
  const [rtoAwb, setRtoAwb] = useState(null);
  const [rtoAdditionalDocs, setRtoAdditionalDocs] = useState(null);
  const [rtoInvoiceValue, setRtoInvoiceValue] = useState(null);
  // Additional-documents modal (Non-ABD B2B shipments only)
  const [addDocsOpen, setAddDocsOpen] = useState(false);
  const [addDocsRow, setAddDocsRow] = useState(null);
  const [apptDocsOpen, setApptDocsOpen] = useState(false);
  // { row, kind: 'appointment' | 'additional' } for the view-only documents dialog
  const [viewDocs, setViewDocs] = useState(null);
  const [apptDocsRow, setApptDocsRow] = useState(null);
  // Single shared action-menu anchor — { anchorEl, row } or null
  const [actionMenu, setActionMenu] = useState(null);
  const closeActionMenu = () => setActionMenu(null);
  const runFromMenu = (fn) => () => { fn?.(); closeActionMenu(); };
  const [appDetails, setAppDetails] = useState(null)
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [ticketId, setTicketId] = useState()
  const [successOpen, setSuccessOpen] = useState(false);
  const [waybillNum, setWaybill] = useState();
  const { data: allCouriers } = useGetCouriersQuery()
  const { blendedData, insuranceDetails } = useSelector(state => state?.report);
  const [insuranceLoading, setInsuranceLoading] = useState(false);
  const [insuranceConfirm, setInsuranceConfirm] = useState(false);
  const [selectedAWB, setSelectedAWB] = useState(null);
  const [abdData, setABDData] = useState(null);
  const [isAbdLoading, setIsAbdLoading] = useState(false);
  const [openAppointmentDelivery, setOpenAppointmentDelivery] = useState(false);
  const [claimModalOpen, setClaimModalOpen] = useState(false);
  const [claimShipment, setClaimShipment] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [bulkLabelLoading, setBulkLabelLoading] = useState(false);
  const merchant = getMerchant();
  const merchantId = merchant?.id ? merchant?.id : ''

  const { getServiceType } = useCourierServiceType();

  const handleOpenClaim = (row) => {
    setClaimShipment(row);
    setClaimModalOpen(true);
  };

  const handleCloseClaim = () => {
    setClaimModalOpen(false);
    setClaimShipment(null);
  };

  const handleClaimSuccess = () => {
    setReload((r) => r + 1);
  };

  const CLAIM_ELIGIBLE_STATUSES = ['DELIVERED', 'RTO_DELIVERED', 'EXCHANGE_DELIVERED', 'PICKUP_PENDING', 'CANCELLED_ORDER'];
  const isClaimEligible = (row) => {
    if (row.shipment_type === "B2B") return false;
    if (!CLAIM_ELIGIBLE_STATUSES.includes(row.orderStatus)) return false;
    return true;
  };

  // Reset page when shipmentType changes
  useEffect(() => {
    setPage(0);
  }, [props.shipmentType]);

  useEffect(() => {
    const andfilter = [];
    const orFilter = [];
    const statusClause = orderStatusClause(props.filters.status);
    if (statusClause) {
      andfilter.push(statusClause);
    } else {
      andfilter.push({
        field: "orderSubStatus",
        operator: "ne",
        value: "UNPROCESSED",
      });
    }
    if (props.shipmentType === 'B2C') {
      andfilter.push({ field: "orderType", operator: "eq", value: 'FORWARD SHIPMENT' });
    }
    andfilter.push({ field: "shipmentType", operator: "eq", value: props.shipmentType });

    if (props.merchantId) {
      andfilter.push({
        field: "merchant.$id",
        operator: "eq",
        value: props.merchantId,
      });
    }
    if (props.filters) {
      const clientOrderFilter = clientOrderIdClause(props.filters);
      if (clientOrderFilter) {
        andfilter.push(clientOrderFilter);
      }
      if (props.filters.awb) {
        // Allow comma-separated AWB lookup. Single value → eq for efficient
        // direct match; multiple values → in with an array.
        const awbList = String(props.filters.awb)
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
        if (awbList.length === 1) {
          andfilter.push({
            field: "awbNumber",
            operator: "eq",
            value: awbList[0],
          });
        } else if (awbList.length > 1) {
          andfilter.push({
            field: "awbNumber",
            operator: "in",
            value: awbList,
          });
        }
      }

      if (props.filters.rtoAwb) {
        andfilter.push({
          field: "rtoAwb",
          operator: "eq",
          value: props.filters.rtoAwb,
        });
      }

      if (props.filters.payment_mode) {
        andfilter.push({
          field: "paymentMode",
          operator: "eq",
          value: props.filters.payment_mode,
        });
      }
      // NETRA RTO risk band (merchant 3-band -> underlying NETRA band values).
      if (props.filters.rtoBand && RTO_BAND3_TO_NETRA[props.filters.rtoBand]) {
        andfilter.push({
          field: "netraRto.band",
          operator: "in",
          value: RTO_BAND3_TO_NETRA[props.filters.rtoBand],
        });
      }
      // NETRA address-quality band (deep-linked from the VAS dashboard).
      if (props.filters.addressBand) {
        andfilter.push({
          field: "netraAddress.band",
          operator: "eq",
          value: props.filters.addressBand,
        });
      }
      if (props.filters.city) {
        andfilter.push({
          field: "deliveryDetails.to_city",
          operator: "eq",
          value: props.filters.city,
        });
      }
      if (props.filters.state) {
        andfilter.push({
          field: "deliveryDetails.to_state",
          operator: "eq",
          value: props.filters.state,
        });
      }
      if (props.filters.fromDate) {
        andfilter.push({
          field: "awbRegisteredDate",
          operator: "gte",
          // value: formatDate(props.filters.fromDate, "yyyy-MM-dd"),
          // value: formatDateForApi(props.filters.fromDate),
          value: `Date('${formatDate(props.filters.fromDate, 'yyyy-MM-dd')} 00:00:00')`
        });
      }
      if (props.filters.toDate) {
        andfilter.push({
          field: "awbRegisteredDate",
          operator: "lte",
          // value: formatDate(props.filters.toDate, "yyyy-MM-dd"),
          // value: formatDateForApi(props.filters.toDate),
          value: `Date('${formatDate(props.filters.toDate, 'yyyy-MM-dd')} 23:59:59')`
        });
      }
      if (props.filters.email) {
        andfilter.push({
          field: "deliveryDetails.to_email",
          operator: "eq",
          value: props.filters.email,
        });
      }
      if (props.filters.phone) {
        andfilter.push({
          field: "deliveryDetails.to_phone_number",
          operator: "eq",
          value: props.filters.phone,
        });
      }
      // eddDate (yyyy-MM-dd, from PTL Delivery Health → Non-ABD → Scheduled today): EDD on that day, cancelled left out,
      // the same rule as the tile's count.
      if (props.filters.eddDate) {
        const next = new Date(`${props.filters.eddDate}T00:00:00`);
        next.setDate(next.getDate() + 1);
        andfilter.push({ field: "edd", operator: "gte", value: `Date('${props.filters.eddDate} 00:00:00')` });
        andfilter.push({ field: "edd", operator: "lt", value: `Date('${formatDate(next, 'yyyy-MM-dd')} 00:00:00')` });
        andfilter.push({ field: "orderStatus", operator: "ne", value: 'CANCELLED_ORDER' });
      }
      // eddBreached (yyyy-MM-dd = today, from PTL Delivery Health → Non-ABD → EDD breaches): the EDD breach rule — EDD
      // before today, not delivered and not on the RTO / cancelled / lost path, AWB registered in the last 90 days.
      if (props.filters.eddBreached) {
        const since = new Date(`${props.filters.eddBreached}T00:00:00`);
        since.setDate(since.getDate() - 90);
        andfilter.push({ field: "edd", operator: "lt", value: `Date('${props.filters.eddBreached} 00:00:00')` });
        andfilter.push({ field: "awbRegisteredDate", operator: "gte", value: `Date('${formatDate(since, 'yyyy-MM-dd')} 00:00:00')` });
        andfilter.push({ field: "orderStatus", operator: "nin", value: EDD_BREACH_CLOSED_STATUSES });
      }
      if (props.filters.appointdeliveryRequired !== undefined && props.filters.appointdeliveryRequired !== null && props.filters.appointdeliveryRequired !== '') {
        andfilter.push(abdFlagFilter(props.filters.appointdeliveryRequired));
      }
    }

    if (props.filters) {
      if (props.filters.reference) {
        orFilter.push({
          field: "reference",
          operator: "eq",
          value: props.filters.reference,
        });
      }
      if (props.filters.reference) {
        orFilter.push({
          field: "shippingLabelId",
          operator: "eq",
          value: props.filters.reference,
        });
      }

    }
    dispatch(resetOrderList());
    dispatch(
      getOrderLists({
        excludes: exclude,
        andfilter: andfilter,
        orfilter: orFilter,
        offset: page * sizePerPage,
        limit: sizePerPage,
        skipCount: true,
        "sort": { "field": "awbRegisteredDate", "direction": "DESC" },
      })
    );
    // setRowCountState(props?.count);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, sizePerPage, props.filterChange, reload, props.shipmentType]);

  const handleSync = (awbNumber, reference, shipmentType) => {
    if (awbNumber) {
      dispatch(syncOrder({ waybill: awbNumber, reference: reference, shipmentType: shipmentType }));
      // console.log(orderListInfo);
    }
  };

  const cloneOrder = (fill) => {
    // getShipmentDetail({
    //   "excludes": "sla,mongoLabelSignedUrlDetails,orderManifest,courierPricing,mongoInvoiceSignedUrlDetails,courierDetail,courier,courierId,merchant,merchantPricing,order_history", andfilter: [{ "field": "awbNumber", "operator": "eq", "value": id }], "offset": 0, "limit": 1
    // }).then((res) => {
    //   let data = res.data.data[0];
    setIsSubmitting(true)
    let newData = {}
    newData.order_type = data.order_type;
    newData.order_date = new Date();
    newData.item_list = data.item_list;
    newData.pickup_details = data.pickup_details;
    newData.delivery_details = data.delivery_details;
    newData.shipment_type = data.shipment_type;
    newData.customer_detail = data.customer_detail;
    newData.shipment_detail = data.shipment_detail;
    newData.invoice_value = data.invoice_value;
    newData.payment_mode = fill.payment_mode;
    newData.cod_amount = fill.payment_mode === "PREPAID" ? 0 : data.invoice_value;
    newData.client_order_id = data.client_order_id;
    newData.invoice_number = data.invoice_number;
    newData.shipping_charge = data.shipping_charge;
    newData.transaction_charge = data.transaction_charge;
    newData.giftwrap_charge = data.giftwrap_charge;
    newData.shippingLabelId = data.shippingLabelId;
    newData.reference = 'c' + data.reference;
    newData.channelOrderUniqueKey = data.channelOrderUniqueKey;
    newData.dispatch_mode = data.dispatch_mode;
    newData.skipRule = fill.courier_type === "Other" ? true : false;
    newData.merchantOId = props.merchantId
    newData.clonedOrderReference = data.reference;

    if (fill.courier_type !== "Other") {
      delete newData.courierPartner;
    } else {
      newData.courier_id = {
        prozoId: fill.courierPartner
      };
      delete newData.courierPartner;
    }

    try {
      // postGeneric(apiConstants.CREATE_ORDER, newData).then((res) => {
      postGeneric(apiConstants.CLONE_ORDER, newData).then((res) => {
        if (res.status === 200) {
          enqueueSnackbar(res?.data?.meta?.message || "Order cloned successfully", { variant: "success" });
          setClone(() => false)
          setIsSubmitting(false)
        }
      }).catch((err) => {
        enqueueSnackbar("Something went wrong while cloning the order", { variant: "error" })
        setIsSubmitting(false)
        setClone(() => false)
      })
    } catch (err) {
      enqueueSnackbar("Something went wrong while cloning the order", { variant: "error" });
      setClone(() => false)
      setIsSubmitting(false)
    }
  };

  const handleClickOpen = (row) => {
    setOpen(true);
    setId(row);
    // console.log(artifactId)
  };
  const handleClickClone = (row, data) => {
    setCourierData(data)
    setClone(true);
    setId(row);
  };

  useEffect(() => {
    if (id && clone) {
      getShipmentDetail({
        "excludes": "sla,mongoLabelSignedUrlDetails,orderManifest,courierPricing,mongoInvoiceSignedUrlDetails,courierDetail,courier,courierId,merchant,merchantPricing,order_history", andfilter: [{ "field": "awbNumber", "operator": "eq", "value": id }], "offset": 0, "limit": 1
      }).then((res) => {
        let data = res.data.data[0]
        console.log(data, 'DATA');
        setData(data)
        setValue("payment_mode", data.payment_mode)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, clone])

  const [fetchLabel, setFetchLabel] = useState(false)

  const handleFetchLabel = (row) => {
    setFetchLabel(true)
    getGeneric(`${apiConstants.FETCH_CUSTOM_LABEL}?orderReference=${row?.reference}`).then((res) => {
      setFetchLabel(false)
      if (res?.data?.labelUrl) {
        enqueueSnackbar("Label Generated Successfully", { variant: "success" });
        setReload(reload => reload + 1)
      }
    }).catch((err) => {
      setFetchLabel(false)
      console.log(err);
      enqueueSnackbar("Some Error Occurred", { variant: "error" });
    })
  };

  const [rtoReceivedConfirm, setRtoReceivedConfirm] = useState(false);
  const [rtoReceivedRow, setRtoReceivedRow] = useState(null);

  const handleMarkRtoReceived = (row) => {
    if (!row) return;
    postGeneric(apiConstants.MARK_RTO_RECEIVED, { awbNumbers: [row.awb_number] }).then((res) => {
      if (res?.data?.status !== 'SUCCESS') {
        const msg = res?.data?.errorMsg || 'Failed to mark RTO Received';
        enqueueSnackbar(typeof msg === 'string' ? msg : 'Failed to mark RTO Received', { variant: 'error' });
        return;
      }
      const result = res?.data?.responseObj || {};
      const failed = (result.results || []).find((r) => r.status === 'FAILED');
      if (failed) {
        enqueueSnackbar(failed.message || 'Failed to mark RTO Received', { variant: 'error' });
      } else {
        enqueueSnackbar('Shipment marked as RTO Received', { variant: 'success' });
        setReload((r) => r + 1);
      }
    }).catch((err) => {
      console.log(err);
      const message = err?.response?.data?.errorMsg || err?.response?.data?.message || 'Something went wrong while marking RTO Received';
      enqueueSnackbar(message, { variant: 'error' });
    })
  };

  const MERCHANT_DOMAINS = {
    '67470509d56298539d20d8f7': 'atovio',
    '669e35c34731fe7eb440a029': 'baidyanathayurved',
    '6814a1d2ecd5fc2c7d8b5d36': 'maapooja',
    '67ea37e8a7208d75355e5959': 'pairietales',
    '67b438fe8579731d83072d3e': 'zwende'
  };


  const columns = [
    {
      field: "actions",
      headerAlign: "center",
      hideSortIcons: true,
      headerName: "Shipment Details",
      flex: 1.3,
      minWidth: 160,
      renderCell: (params) => {
        const { row } = params;
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>{row.reference}</Typography>
            {row.shippingLabelId && row.reference !== row.shippingLabelId && (
              <Typography sx={secondaryTextSx}>{row.shippingLabelId}</Typography>
            )}
            <ClientOrderIdText row={row} />
            <Typography sx={secondaryTextSx}>
              {row.createdDate ? parseDateAndTime(row.createdDate) : ""}
            </Typography>
            {row.channel_name && row.channel_name !== "Unicom" && row.channel_name !== "WMS" && (
              <Typography sx={tertiaryTextSx}>{row.channel_name}</Typography>
            )}
            {(row.orderTags || []).some((t) => String(t).toUpperCase().includes('KCI')) && (
              <Tooltip title='This shipment was tagged by a KCI (Keep Customers Informed) event — its delay is attributed to a known external disruption.'>
                <Chip label="KCI Impacted" size="small"
                  sx={{ alignSelf: 'flex-start', mt: 0.5, height: 18, fontSize: 10, fontWeight: 700, bgcolor: '#FFF3E0', color: '#E65100', border: '1px solid #E6510055' }} />
              </Tooltip>
            )}
          </Box>
        );
      },
    },
    {
      field: "courier",
      headerAlign: "center",
      hideSortIcons: true,
      headerName: "Courier Partner",
      flex: 1,
      minWidth: 140,
      renderCell: (params) => {
        const { row } = params;
        let courierParent = row.courierDetail?.parent?.includes('Blended') ? row.actualCourierProviderName : row.courierDetail?.parent;
        const serviceType = getServiceType(row.courierDetail?.prozoId);
        return (
          <Box sx={cellStackSx}>
            <AwbLinkCell awb={row.awb_number} sx={awbTextSx} />
            <Typography sx={secondaryTextSx}>{courierParent}</Typography>
            {serviceType && <Typography sx={tertiaryTextSx}>{serviceType}</Typography>}
          </Box>
        );
      },
    },
    {
      field: "delivery",
      headerAlign: "center",
      hideSortIcons: true,
      headerName: "Delivery Details",
      flex: 1.5,
      minWidth: 180,
      renderCell: (params) => {
        const { row } = params;
        const pickupName = row.pickup_details?.from_name || "";
        const pickupPin = row.pickup_details?.from_pincode || "";
        const deliveryName = row.delivery_details?.to_name || "";
        const deliveryPin = (row.delivery_details?.to_pincode)
          ? (shouldMaskData(report, row, piiAccessAllow)
            ? maskAddress(row.delivery_details.to_pincode)
            : row.delivery_details.to_pincode)
          : "";
        return (
          <Box sx={cellStackSx}>
            <Typography sx={secondaryTextSx}>
              <Typography component="span" sx={{ ...primaryTextSx, fontSize: 'inherit' }}>Pickup: </Typography>
              {pickupName}{pickupPin ? `, ${pickupPin}` : ""}
            </Typography>
            <Typography sx={secondaryTextSx}>
              <Typography component="span" sx={{ ...primaryTextSx, fontSize: 'inherit' }}>Delivery: </Typography>
              {deliveryName}{deliveryPin ? `, ${deliveryPin}` : ""}
            </Typography>
            {row.netra_address && (
              <Box sx={{ mt: 0.3 }}>
                <NetraScoreBadge netra={row.netra_address} orderId={row.id} />
              </Box>
            )}
            {row.netra_rto && (
              <Box sx={{ mt: 0.3 }}>
                <RtoRiskBadge netra={row.netra_rto} orderId={row.id} />
              </Box>
            )}
          </Box>
        );
      },
    },
    {
      field: "shipment",
      headerAlign: "center",
      hideSortIcons: true,
      headerName: "Package Details",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        const { row } = params;
        const sd = row.shipment_detail?.[0];
        return (
          <Box sx={cellStackSx}>
            <Typography sx={secondaryTextSx}>
              DW: {sd ? `${(sd.item_weight / 1000).toFixed(2)} kg` : ""}
            </Typography>
            {row.shipment_type !== 'B2B' && (
              <Typography sx={secondaryTextSx}>
                VW: {sd ? `${((sd.item_length * sd.item_breadth * sd.item_height) / 5000).toFixed(2)} kg` : ""}
              </Typography>
            )}
            {row.shipment_type !== 'B2B' && sd && (
              <Typography sx={tertiaryTextSx}>
                {sd.item_length} x {sd.item_breadth} x {sd.item_height} cm
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      field: "itemDetails",
      headerAlign: "center",
      hideSortIcons: true,
      headerName: "Item Details",
      flex: 0.7,
      minWidth: 90,
      renderCell: (params) => {
        const { row } = params;
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>
              {getTotalUnitsOfOrder(row.item_list)} units
            </Typography>
            <MuiLink
              component="button"
              variant="body2"
              sx={{ fontSize: 11, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
              onClick={() => {
                setItemModalData(row.item_list);
                setItemModal(true);
              }}
            >
              View Items
            </MuiLink>
          </Box>
        );
      },
    },
    {
      field: "paymentDetails",
      headerAlign: "center",
      hideSortIcons: true,
      headerName: "Payment Details",
      flex: 0.7,
      minWidth: 100,
      renderCell: (params) => {
        const { row } = params;
        const paymentMode = row.payment_mode || "";
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>
              {row.invoice_value ? formatCurrency(row.invoice_value) : ""}
            </Typography>
            {paymentMode && (
              <Chip size="small" label={paymentMode} sx={getPaymentChipSx(paymentMode)} />
            )}
          </Box>
        );
      },
    },
    {
      field: "statusDetails",
      headerAlign: "center",
      hideSortIcons: true,
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        const { row } = params;
        return (
          <Stack spacing={1} alignItems="center">
            <Chip size="small" label={row.orderStatus} sx={getStatusChipSx(row.orderStatus)} />
            {row.orderSubStatus === 'RTO_RECEIVED' && (
              <Chip variant="outlined" size="small" color="success" label="RTO Received" />
            )}
          </Stack>
        );
      },
    },

    // PTL lists: view the shipment's PoD straight from the row.
    ...(props.shipmentType === 'B2B'
      ? [{
        field: "pods",
        headerName: "PoD",
        headerAlign: "center",
        align: "center",
        hideSortIcons: true,
        flex: 0.6,
        minWidth: 90,
        renderCell: ({ row }) => <PodViewCell row={row} />,
      }] : []),
    ...((location.pathname === '/b2b-orders')
      ? [{
        field: "appointdeliveryRequired",
        headerName: "Type",
        headerAlign: "center",
        hideSortIcons: true,
        flex: 1,
        minWidth: 110,
        renderCell: (params) => {
          const { row } = params;
          const currentMode = row.appointdeliveryRequired ? "ABD" : "Non-ABD";
          const nextMode = row.appointdeliveryRequired ? "Non-ABD" : "ABD";
          return !row?.terminalStatus ? (
            <Stack direction="column" spacing={0.5} alignItems="center">
              <Typography variant="body2" fontWeight={500}>
                {currentMode}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                Toggle to switch to {nextMode}
              </Typography>
              <Tooltip title={`Switch to ${nextMode} Mode`}>
                <Switch
                  checked={row.appointdeliveryRequired}
                  disabled={isAbdLoading}
                  color="primary"
                  size="small"
                  onChange={() => handleAppointmentDeliveryFunc(row)}
                />
              </Tooltip>
            </Stack>
          ) : (
            "-"
          );
        },
      }] : []),
    {
      field: "action",
      headerAlign: "center",
      hideSortIcons: true,
      headerName: "Action",
      flex: 1.1,
      minWidth: 160,
      renderCell: (params) => {
        const { row } = params;
        return (
          <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="center" sx={{ width: '100%' }}>
            <Button
              variant="contained"
              size="small"
              component={Link}
              to={`/order-detail?waybill=${row.awb_number}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ whiteSpace: 'nowrap', textTransform: 'none', fontWeight: 600, px: 2, fontSize: 12 }}
            >
              Details
            </Button>
            <Tooltip title="More actions">
              <IconButton
                size="small"
                onClick={(e) => setActionMenu({ anchorEl: e.currentTarget, row })}
                sx={{
                  bgcolor: 'background.paper',
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  width: 32,
                  height: 32,
                  '&:hover': { bgcolor: 'grey.100' },
                }}
              >
                <MoreVertIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    },
  ];

  // Single Menu rendered outside the grid for the row chosen via ⋮. Keeps the
  // grid lightweight (no per-row anchor state) and the menu mounted once.
  const renderActionMenu = () => {
    const row = actionMenu?.row;
    if (!row) return null;
    const isB2B = row?.shipment_type === "B2B";
    const isNonTerminal = !row.terminalStatus;
    const showInsurance =
      insuranceDetails && isNonTerminal &&
      row?.invoice_value >= insuranceDetails?.autoEnabledForMinInvoiceValue;
    const showFetchLabel =
      isB2B && row?.courierDetail?.parent === "Delhivery" && !row?.label_url &&
      ["AWB_REGISTERED", "PICKUP_PENDING", "ORDER_PLACED"].includes(row?.orderStatus);
    const showClaimRow = CLAIM_ELIGIBLE_STATUSES.includes(row?.orderStatus) && !isB2B;
    const showMarkRto = isB2B && !isRtoBlocked(row?.orderStatus);
    // Backend gate is hasAnyRole(ROLE_ADMIN, ROLE_PROSHIPADMIN) — hide from ROLE_USER sub-users.
    const rolesForRtoReceived = getRole() || [];
    const showMarkRtoReceived = row?.orderStatus === "RTO_DELIVERED" && row?.orderSubStatus !== "RTO_RECEIVED"
      && (rolesForRtoReceived.includes('ROLE_ADMIN') || rolesForRtoReceived.includes('ROLE_PROSHIPADMIN'));
    const cancelDisabled = ["CANCELLED_ORDER", "DELIVERED", "FAILED_DELIVERY", "CANCELLED_PENDING"].includes(row?.orderStatus);
    return (
      <Menu
        anchorEl={actionMenu?.anchorEl}
        open={Boolean(actionMenu)}
        onClose={closeActionMenu}
        PaperProps={{ sx: { minWidth: 200, '& .MuiMenuItem-root': { fontSize: 12, py: 0.75 }, '& .MuiListItemText-primary': { fontSize: 12 }, '& .MuiListItemIcon-root': { minWidth: 28 } } }}
      >
        {/* Context actions (B2B scheduling + Non-ABD doc upload + insurance) */}
        {isB2B && isNonTerminal && (
          <MenuItem onClick={runFromMenu(() => handleDelivery(row))}>
            <ListItemIcon><CalendarMonthIcon fontSize="small" /></ListItemIcon>
            <ListItemText>{row.appointmentDelivery ? "Reschedule" : "Schedule"}</ListItemText>
          </MenuItem>
        )}
        {isB2B && isNonTerminal && !row.appointdeliveryRequired && (
          <MenuItem onClick={runFromMenu(() => { setAddDocsRow(row); setAddDocsOpen(true); })}>
            <ListItemIcon><DescriptionIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Add Documents</ListItemText>
          </MenuItem>
        )}
        {isB2B && isNonTerminal && row.appointmentDelivery && row.appointmentDeliveryData && (
          <MenuItem onClick={runFromMenu(() => { setApptDocsRow(row); setApptDocsOpen(true); })}>
            <ListItemIcon><DescriptionIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Add Documents to Appointment</ListItemText>
          </MenuItem>
        )}
        {/* View-only documents, as the Admin Panel's PTL shipment list */}
        {isB2B && row?.appointmentDeliveryData && (
          <MenuItem onClick={runFromMenu(() => setViewDocs({ row, kind: 'appointment' }))}>
            <ListItemIcon><AssignmentIcon fontSize="small" /></ListItemIcon>
            <ListItemText>View appointment details</ListItemText>
          </MenuItem>
        )}
        {isB2B && row?.additionalDocuments && (
          <MenuItem onClick={runFromMenu(() => setViewDocs({ row, kind: 'additional' }))}>
            <ListItemIcon><DescriptionIcon fontSize="small" /></ListItemIcon>
            <ListItemText>View additional documents</ListItemText>
          </MenuItem>
        )}
        {showInsurance && (
          <MenuItem
            disabled={!!row?.symboProposalRefString}
            onClick={runFromMenu(() => handleInsurance(row?.awb_number))}
          >
            <ListItemIcon><HealthAndSafetyIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Add Insurance</ListItemText>
          </MenuItem>
        )}
        {(isB2B && (isNonTerminal || row?.appointmentDeliveryData || row?.additionalDocuments)) || showInsurance ? <Divider /> : null}

        {/* Common actions */}
        <MenuItem onClick={runFromMenu(() => isB2B
          ? handleClickClone(row.awb_number, row)
          : (setCloneWithEditRow(row), setCloneWithEdit(true))
        )}>
          <ListItemIcon><ContentCopyIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Clone</ListItemText>
        </MenuItem>
        <MenuItem onClick={runFromMenu(() => handleSync(row.awb_number, row?.reference, row?.shipment_type))}>
          <ListItemIcon><SyncIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Resync</ListItemText>
        </MenuItem>
        <MenuItem onClick={runFromMenu(() => handleClickOpen(row.id))}>
          <ListItemIcon><CommentOutlinedIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Remark</ListItemText>
        </MenuItem>
        <MenuItem onClick={runFromMenu(() => {
          const domain = MERCHANT_DOMAINS[merchantId] || 't';
          window.open(`https://${domain}.proship.in/${row.awb_number}`, '_blank');
        })}>
          <ListItemIcon><LocalShippingOutlinedIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Track</ListItemText>
        </MenuItem>
        {showFetchLabel && (
          <MenuItem onClick={runFromMenu(() => handleFetchLabel(row))}>
            <ListItemIcon><PrintOutlinedIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Fetch Label</ListItemText>
          </MenuItem>
        )}
        {/* B2C only — reverse shipments for B2B/PTL go through their own flow.
           Only meaningful once the forward shipment is actually delivered. */}
        {!isB2B && (
          <MenuItem
            disabled={row?.orderStatus !== 'DELIVERED' || row?.order_type === 'REVERSE SHIPMENT'}
            onClick={runFromMenu(() => navigate(`/create-order-rvp?awb=${row.awb_number}`))}
          >
            <ListItemIcon><ReplayIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Create Reverse Order</ListItemText>
          </MenuItem>
        )}

        {/* Claim row — only DELIVERED B2C */}
        {showClaimRow && (row?.claimId || row?.claim_id) && (
          <MenuItem component={Link} to={`/claims/${row.claimId || row.claim_id}`} onClick={closeActionMenu}>
            <ListItemIcon><GavelOutlinedIcon fontSize="small" sx={{ color: 'success.main' }} /></ListItemIcon>
            <ListItemText>Claim Raised</ListItemText>
          </MenuItem>
        )}
        {showClaimRow && !(row?.claimId || row?.claim_id) && row?.claimWindowExpired && (
          <MenuItem disabled>
            <ListItemIcon><GavelOutlinedIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Claim Window Closed</ListItemText>
          </MenuItem>
        )}
        {showClaimRow && !(row?.claimId || row?.claim_id) && !row?.claimWindowExpired && isClaimEligible(row) && (
          <MenuItem onClick={runFromMenu(() => handleOpenClaim(row))}>
            <ListItemIcon><GavelOutlinedIcon fontSize="small" sx={{ color: 'primary.main' }} /></ListItemIcon>
            <ListItemText>Raise Claim</ListItemText>
          </MenuItem>
        )}

        {showMarkRto && (
          <MenuItem onClick={runFromMenu(() => { setRtoAwb(row.awb_number); setRtoAdditionalDocs(row.additionalDocuments || null); setRtoInvoiceValue(row.invoice_value); setRtoModalOpen(true); })}>
            <ListItemIcon><AssignmentReturnOutlinedIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Mark RTO</ListItemText>
          </MenuItem>
        )}

        {showMarkRtoReceived && (
          <MenuItem onClick={runFromMenu(() => { setRtoReceivedRow(row); setRtoReceivedConfirm(true); })}>
            <ListItemIcon><AssignmentTurnedInOutlinedIcon fontSize="small" sx={{ color: 'success.main' }} /></ListItemIcon>
            <ListItemText>Mark RTO Received</ListItemText>
          </MenuItem>
        )}

        {/* Destructive — separated, red */}
        <Divider />
        <MenuItem
          disabled={cancelDisabled}
          onClick={runFromMenu(() => toggleCancel(row.awb_number))}
          sx={{ color: 'error.main', '&:hover': { bgcolor: 'rgba(244,67,54,0.08)' } }}
        >
          <ListItemIcon><CancelOutlinedIcon fontSize="small" sx={{ color: 'error.main' }} /></ListItemIcon>
          <ListItemText>Cancel Order</ListItemText>
        </MenuItem>
      </Menu>
    );
  };



  // Switch-related functions
  const handleAppointmentDeliveryAgree = async () => {
    setIsAbdLoading(true);
    try {
      const response = await postGeneric(
        `${apiConstants.TOGGLE_APPOINTMENT_DELIVERY}?awbNumber=${abdData.awb_number}&statusCode=${!abdData.appointdeliveryRequired}&merchantOid=${merchantId}`
      );
      enqueueSnackbar(
        response?.data?.message || "Appointment Delivery Updated Successfully",
        { variant: 'success' }
      );
      handleCloseAppointmentDelivery();
      setReload((reload) => reload + 1)
    } catch (error) {
      console.error('Appointment delivery update failed:', error);
      enqueueSnackbar(
        error?.response?.data?.message || "Failed to update appointment delivery",
        { variant: 'error' }
      );
    } finally {
      setIsAbdLoading(false);
    }
  };

  const handleCloseAppointmentDelivery = () => {
    setOpenAppointmentDelivery(false);
    setABDData(null);
    setIsAbdLoading(false);
  };

  const handleAppointmentDeliveryFunc = (rowData) => {
    setABDData(rowData);
    setOpenAppointmentDelivery(true);
  };



  const handleInsurance = (val) => {
    setSelectedAWB(val);
    setInsuranceConfirm(true);
  };

  const confirmInsurance = () => {
    setInsuranceLoading(true);
    postGeneric(`${apiConstants.CREATE_INSURANCE_PROPOSAL}`, {
      awbNumber: selectedAWB
    }).then((res) => {
      if (res?.status === 200) {
        enqueueSnackbar(res?.data?.message || 'Insurance proposal created successfully', { variant: 'success' });
      } else {
        enqueueSnackbar(res?.data?.message || 'Something went wrong', { variant: 'error' });
      }
    }).catch((err) => {
      console.log(err);
      const errorMessage = err?.response?.data?.message;
      if (errorMessage?.includes('Proposal already exists')) {
        enqueueSnackbar('Proposal already exists in draft state', { variant: 'error' });
      } else {
        enqueueSnackbar(errorMessage || "Something went wrong", { variant: "error" });
      }
    }).finally(() => {
      setInsuranceLoading(false);
      setInsuranceConfirm(false);
      setSelectedAWB(null);
      setReload(reload + 1);
    })
  }

  const handleDelivery = (val) => {
    setDelConfirm(true);
    setAppDetails(val)
  };
  const toggleCancel = (val) => {
    setCancelConfirm(true);
    setWaybill(val)
  };

  // useEffect(() => {
  //   setRowCountState((prevRowCountState) =>
  //     props?.count !== undefined ? props?.count : prevRowCountState
  //   );
  // }, [props?.count, setRowCountState]);

  const dispatch_mode = watch('dispatch_mode')
  const callShipmentRateCalculator = (pincodeResponse) => {
    const pickup_details = {
      from_address: courierData?.pickup_details?.address_line,
      from_city: courierData?.pickup_details?.city,
      from_country: courierData?.pickup_details?.country,
      from_name: courierData?.pickup_details?.name,
      from_pincode: pincodeResponse?.pickupPincode,
      from_state: courierData?.pickup_details?.state,
      from_phone_number: courierData?.pickup_details?.contactNumber,
      from_email: courierData?.pickup_details?.email,
      gstin: courierData?.pickup_details?.gstin
    }

    let length = _.sumBy(courierData?.shipment_detail, "item_length")
    let breadth = _.sumBy(courierData?.shipment_detail, "item_breadth")
    let height = _.sumBy(courierData?.shipment_detail, "item_height")
    let weight = _.sumBy(courierData?.shipment_detail, "item_weight")
    if (pickup_details) {
      postGeneric(`${apiConstants.SHIPMENT_RATE_CALCULATOR}`, {
        orderType: "FORWARD",
        to: parseInt(pincodeResponse?.deliveryPincode),
        from: parseInt(pickup_details?.from_pincode),
        paymentType: courierData?.payment_mode.toLowerCase() === "prepaid" ? "PREPAID" : "COD",
        "length": length,
        "breadth": breadth,
        "height": height,
        "weight": weight,
        // "dispatchMode": "SURFACE",
        ...(dispatch_mode !== "ANY" ? { dispatchMode: dispatch_mode } : {}),
        "codAmount": Number(courierData.cod_amount) || 0,
        "isMerchant": true,
        onlyCouriersAsPerRuleMapping: true, checkServiceable: true,
        merchantOid: props.merchantId
      }).then((res) => {
        setIsLoading(false)
        const pricing = res?.data;
        const newCourier = allCouriers?.map((d) => {
          const updatedCourier = { ...d };
          pricing.forEach((t) => {
            if (t.provider?.id === updatedCourier.prozoId) {
              updatedCourier.priceAfterTax = t.priceAfterTax;
              updatedCourier.providerMinTatDays = t.providerMinTatDays;
              updatedCourier.providerMaxTatDays = t.providerMaxTatDays;
            }
          });
          return updatedCourier;
        })
        let filteredCouriers = newCourier.filter(item =>
          item.priceAfterTax &&
          item.type === 'FORWARD')
        const now = new Date();
        filteredCouriers.forEach(shipment => {
          let minTatDays = shipment.providerMinTatDays || 0;
          let maxTatDays = shipment.providerMaxTatDays || 0;
          shipment.minDeliveryDate = format(addDays(now, minTatDays), 'dd, MMM');
          shipment.maxDeliveryDate = format(addDays(now, maxTatDays), 'dd, MMM');
        });
        setNewCourier(filteredCouriers);
      }).catch((err) => {
        console.log(err)
        enqueueSnackbar(err?.response?.data?.message || "Something went wrong", { variant: "error" });
        setIsLoading(false)
      })
    }
  }

  useEffect(() => {
    if (courierData && courierSelection === "Other") {
      setIsLoading(true)

      // First call get pincodes API
      getGeneric(`${apiConstants.GET_PINCODES}?merchantOid=${merchantId}&awbNumber=${courierData?.awb_number}`)
        .then((res) => {
          callShipmentRateCalculator(res?.data);
        })
        .catch((err) => {
          console.log('Error fetching pincodes:', err);
          enqueueSnackbar("Error fetching pincode data", { variant: "error" });
          setIsLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courierSelection, courierData, dispatch_mode])

  const cancelOrder = () => {
    // setLoading(true);
    get(`${apiConstants.BASE_LOCAL}${apiConstants.CANCEL_ORDER}?waybill=${waybillNum}`).then(response => {
      // setLoading(false);      
      let rs = response.data;
      if (rs.meta && rs.meta.status && rs.meta.status === "200") {
        enqueueSnackbar("Cancelled successfully", { variant: 'success' });
        setReload(reload + 1);
      }
      if (rs.meta && rs.meta.status && rs.meta.status === "350") {
        enqueueSnackbar("Unable to cancel with courier partner at this point", { variant: 'warning' });
      }
      else if (rs.meta && rs.meta.status && rs.meta.status === "603") {
        enqueueSnackbar("Courier partner API cancellation not supported", { variant: 'error' });
      }
      else if (rs.meta && rs.meta.status && rs.meta.status === "CANCELLED_PENDING") {
        enqueueSnackbar(rs.meta.message, { variant: 'success' });
        setReload(reload + 1)
      }
      else if (rs.meta && rs.meta.status && rs.meta.status !== "200" && rs.meta.status !== "350" && rs.meta.status !== "603" && rs.meta.status !== "CANCELLED_PENDING") {
        enqueueSnackbar(rs.meta.message, { variant: 'warning' });
      }
      // dispatch(getOrderLists({ "andfilter": andfilter, "offset": 0, "limit": 1 }));
    })
      .catch(err => {
        console.error(err);
      });
  }

  const handleOpen = () => {
    setSuccessOpen(true)
    setSidebarOpen(false)
  }

  const bulkDownloadLabelsHandler = () => {
    const awbs = (orderListInfo.data || [])
      .filter((row) => selectedRows.includes(row.id))
      .map((row) => row.awb_number)
      .filter(Boolean);
    setBulkLabelLoading(true);
    postGeneric(apiConstants.GET_BULK_LABELS, { awbList: awbs })
      .then(({ data }) => {
        window.open(data.mergedPdf, true);
      })
      .catch((err) => {
        console.error(err);
        enqueueSnackbar("Something went wrong while downloading labels", { variant: "error" });
      })
      .finally(() => setBulkLabelLoading(false));
  };

  return (
    <>
      <Grid item container spacing={2}>
        {(loading || orderSummaryLoading || fetchLabel || insuranceLoading) && <Loader />}
        <ItemListModal data={itemModalData} itemModal={itemModal} setItemModal={setItemModal} />
        {selectedRows.length > 0 && (
          <Grid item xs={12}>
            <Stack direction="row" sx={{ mb: 1, justifyContent: "flex-end" }}>
              <LoadingButton
                loading={bulkLabelLoading}
                onClick={bulkDownloadLabelsHandler}
                variant="contained"
                startIcon={<DownloadIcon />}
              >
                Download Labels
              </LoadingButton>
            </Stack>
          </Grid>
        )}
        <Grid item xs={12}>
          <ProzoDataGrid
            columns={columns}
            // disableColumnFilter={true}rowsPerPageOptions
            autoHeight={true}
            rows={
              orderListInfo.data && orderListInfo.data.length > 0
                ? orderListInfo.data
                : []
            }
            sizePerPage={sizePerPage}
            setSizePerPage={setSizePerPage}
            setPage={setPage}
            page={page}
            pagination={true}
            hideFooterPagination={false}
            filterMode={"server"}
            // rowCount={rowCountState || 0}
            rowCount={lastPageRowCount({ page, pageSize: sizePerPage, rowsOnPage: orderListInfo?.data?.length, loading })}
            getRowId={(row) => row.id}
            checkboxSelection
            onSelectionModelChange={(_ids) => setSelectedRows(_ids)}
          />
        </Grid>
      </Grid>

      <MUIModal
        open={open}
        handleClose={() => setOpen(false)}
        title={"Add Remarks"}
        hideClose={true}
      > <Remarks
          id={id}
          on={"ORDER"}
          setReload={setReload}
          reload={reload}
          setOpen={setOpen}
        />
      </MUIModal>
      <MUIModal
        open={delConfirm}
        handleClose={() => setDelConfirm(false)}
        title={
          <Typography variant="subtitle1" sx={{ mt: 1 }}>
            Schedule Delivery Appointment - AWB{' : '}
            <Typography component="span" color="error" fontWeight="bold">
              {appDetails?.awb_number}
            </Typography>
          </Typography>
        }
        hideClose={true}
      >
        <AppointmentDelivery
          rowData={appDetails}
          setDelConfirm={setDelConfirm}
          setReload={setReload}
        />
      </MUIModal>

      <MUIModal
        open={addDocsOpen}
        handleClose={() => setAddDocsOpen(false)}
        title={
          <Typography variant="subtitle1" sx={{ mt: 1 }}>
            Add Documents &amp; Receiver Contact - AWB{' : '}
            <Typography component="span" color="error" fontWeight="bold">
              {addDocsRow?.awb_number}
            </Typography>
          </Typography>
        }
        hideClose={true}
        maxWidth="md"
      >
        <AddAdditionalDocuments
          rowData={addDocsRow}
          setOpen={setAddDocsOpen}
          setReload={setReload}
        />
      </MUIModal>

      <MUIModal
        open={apptDocsOpen}
        handleClose={() => { setApptDocsOpen(false); setApptDocsRow(null); }}
        title={
          <Typography variant="subtitle1" sx={{ mt: 1 }}>
            Add Documents to Appointment - AWB{' : '}
            <Typography component="span" color="error" fontWeight="bold">
              {apptDocsRow?.awb_number}
            </Typography>
          </Typography>
        }
        hideClose={true}
        maxWidth="md"
      >
        <DocumentsModal
          rowData={apptDocsRow}
          setOpen={setApptDocsOpen}
          setReload={setReload}
        />
      </MUIModal>

      <MUIModal
        open={!!viewDocs}
        handleClose={() => setViewDocs(null)}
        title={
          <Typography variant="subtitle1" sx={{ mt: 1 }}>
            {VIEW_DOCS_TITLES[viewDocs?.kind]} - AWB{' : '}
            <Typography component="span" color="error" fontWeight="bold">
              {viewDocs?.row?.awb_number}
            </Typography>
          </Typography>
        }
        maxWidth="sm"
      >
        {viewDocs && <ViewDocumentsDialog row={viewDocs.row} kind={viewDocs.kind} />}
      </MUIModal>

      {/* Shared row-action overflow menu */}
      {renderActionMenu()}

      {/* <ConfirmDialog
        title='Are you sure you want to clone this order?'
        open={clone}
        setOpen={setClone}
        onConfirm={() => cloneOrder()}>
        Are you sure you want to clone this order?
        <FormProvider methods={methods} onSubmit={handleSubmit(cloneOrder)}>
          <RHFSelectField name='payment_mode' label='Payment Mode' options={paymentMode.map((val) => ({
            value: val.value,
            label: val.label
          }))} />
        </FormProvider>
      </ConfirmDialog> */}
      <MUIModal
        maxWidth="lg"
        open={clone}
        handleClose={() => { setClone(false); resetClone() }}
        title={"Are you sure you want to clone this order?"}
        hideClose={true}
      // sx={{ width: '100%', justifyContent: 'center' }}
      >
        <FormProvider methods={methods} onSubmit={handleSubmit(cloneOrder)}>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <RHFSelectField name='payment_mode' width={"100%"} label='Payment Mode' options={paymentMode.map((val) => ({
                value: val.value,
                label: val.label
              }))} />
            </Grid>
            {blendedData ?
              <Grid item xs={12} sx={{ mt: 1, ml: 1 }}>
                <RHFRadioGroup label="Courier Selection" name="courier_type" options={[
                  {
                    label: "As per Recommendation Rules",
                    value: "Prozo Choice",
                  },
                ]}
                />
              </Grid> :

              <Grid item xs={12} sx={{ mt: 1, ml: 1 }}>
                <RHFRadioGroup label="Courier Selection" name="courier_type" options={[
                  {
                    label: "As per Recommendation Rules",
                    value: "Prozo Choice",
                  },
                  { label: "Other Courier", value: "Other" },
                ]}
                />
              </Grid>
            }
            {courierSelection === 'Other' && (
              <Grid item xs={12}>
                <RHFSelectField
                  variant='filled'
                  width='100%'
                  name='dispatch_mode'
                  label='Dispatch Mode'
                  options={[{ label: 'Any', value: 'ANY' }, { label: 'Surface', value: 'SURFACE' }, { label: 'Air', value: 'AIR' }]}
                />
              </Grid>
            )}
            {isLoading ? <Loader /> :
              <>
                {courierSelection === 'Other' && (
                  <Grid item xs={12}>
                    <RHFSelectField
                      variant="filled"
                      width="100%"
                      name="courierPartner"
                      label="Courier Partner"
                      noOptionsText='No courier partner available for this pickup location'
                      options={(newCourier)?.filter(row => !row.isExternal).map((c) => {
                        return {
                          label:
                            <Grid container spacing={0}>
                              <Grid item xs={4}>
                                <Typography variant="body2">{c?.name}</Typography>
                              </Grid>
                              <Grid item xs={2}>
                                <Typography variant="body2">{formatCurrency(c?.priceAfterTax)}</Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <Typography variant="body2">
                                  {c.providerMinTatDays !== undefined && c.providerMaxTatDays !== undefined && c.providerMaxTatDays > 0 ?
                                    `TAT: ${c.providerMinTatDays}-${c.providerMaxTatDays} Days` :
                                    'TAT: Not Available'}
                                </Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <Typography variant="body2">
                                  {c.providerMinTatDays !== undefined && c.providerMaxTatDays !== undefined && c.providerMaxTatDays > 0 ?
                                    `EDD: ${c.minDeliveryDate}-${c.maxDeliveryDate}` :
                                    'EDD: Not Available'}
                                </Typography>
                              </Grid>
                            </Grid>,
                          value: c?.prozoId
                        };
                      })}
                    />
                  </Grid>
                )}
              </>
            }
            <Grid item xs={12} sx={{ display: "flex", justifyContent: 'center', p: 2 }}>
              <Button variant="contained" color="error" onClick={() => setClone(false)}>No</Button>
              <LoadingButton loading={isSubmitting} variant="contained" color="success" type='submit' sx={{ ml: 1 }}>YES</LoadingButton>
            </Grid>
          </Grid>
        </FormProvider>
      </MUIModal>
      <CloneWithEditModal
        open={cloneWithEdit}
        onClose={() => { setCloneWithEdit(false); setCloneWithEditRow(null); }}
        orderId={cloneWithEditRow?.awb_number}
        orderData={cloneWithEditRow}
        merchantId={merchantId}
        onSuccess={() => setReload((r) => r + 1)}
      />
      <MarkRtoRequestedModal
        open={rtoModalOpen}
        onClose={() => { setRtoModalOpen(false); setRtoAwb(null); setRtoAdditionalDocs(null); setRtoInvoiceValue(null); }}
        awbNumber={rtoAwb}
        additionalDocuments={rtoAdditionalDocs}
        invoiceValue={rtoInvoiceValue}
        onSuccess={() => setReload((r) => r + 1)}
      />
      <SideDrawer title='Create a support ticket' subtitle='Provide details to raise a support case' open={sidebarOpen ? true : false} setOpen={() => setSidebarOpen(false)} children={<CreateTicket handleOpen={handleOpen} setTicketId={setTicketId} awb={appDetails} />}>
      </SideDrawer>
      <TicketSuccessModal open={successOpen} handleClose={() => setSuccessOpen(false)} ticketId={ticketId} />
      <ConfirmDialog
        title=''
        open={cancelConfirm}
        setOpen={setCancelConfirm}
        onConfirm={() => cancelOrder()}
      >
        Are you sure you want to cancel this order ?
      </ConfirmDialog>
      <ConfirmDialog
        title={
          <>
            <Typography variant="h6" component="div">
              Confirm ABD-Non-ABD Conversion
            </Typography>
            {abdData && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                AWB: <strong>{abdData.awb_number}</strong>
              </Typography>
            )}
          </>
        }
        open={openAppointmentDelivery}
        setOpen={setOpenAppointmentDelivery}
        onConfirm={() => handleAppointmentDeliveryAgree()}
      >
        {<>
          <Typography variant="body1" sx={{ mb: 1 }}>
            This shipment is being converted to{" "}
            <strong>
              {!abdData?.appointdeliveryRequired
                ? "Appointment-Based Delivery (ABD)"
                : "Non-Appointment-Based Delivery (Non-ABD)"}
            </strong>
          </Typography>

          {!abdData?.appointdeliveryRequired && (
            <Typography variant="body2" sx={{ mb: 1 }}>
              Please ensure that the Appointment Date is set using the yellow calendar icon (📅).
            </Typography>
          )}

          {!abdData?.appointdeliveryRequired && (
            <Typography variant="body2" sx={{ mb: 2 }}>
              TAT will now be calculated based on the Appointment Date.
            </Typography>
          )}

          <Typography variant="body1" fontWeight="medium">
            Do you wish to proceed?
          </Typography>
        </>}
      </ConfirmDialog>

      <ConfirmDialog
        title=''
        open={insuranceConfirm}
        setOpen={setInsuranceConfirm}
        onConfirm={() => confirmInsurance()}
      >
        Are you sure you want to create an insurance proposal for this order?
      </ConfirmDialog>
      <ConfirmDialog
        title='Mark RTO Received'
        open={rtoReceivedConfirm}
        setOpen={setRtoReceivedConfirm}
        onConfirm={() => handleMarkRtoReceived(rtoReceivedRow)}
      >
        Mark shipment <strong>{rtoReceivedRow?.awb_number}</strong> as physically received back?
        This confirms the RTO shipment has reached you and cannot be undone from the panel.
      </ConfirmDialog>
      <RaiseClaimModal
        open={claimModalOpen}
        onClose={handleCloseClaim}
        shipment={claimShipment}
        merchantId={merchantId}
        onSuccess={handleClaimSuccess}
      />
    </>
  );
};

export default AllOrders;
